<template>
    <nav-bar-layout>
        <template #left_slot>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'user-account'}"
                    class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                >
                    <vue-feather class="mr-20" type="user"  size="15"></vue-feather>
                    <span>{{ localizationStore.translate('my.account') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'family-index'}"
                    aria-current="page"
                    class="nav-link d-flex align-items-center px-50 text-primary"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="users"  size="15"></vue-feather>
                    <span>{{ localizationStore.translate('family') }}</span>
                </router-link>
            </li>
            <!-- <li class="nav-item knowledge_center">
                <router-link
                    :to="{ name: 'knowledge-base-index'}"
                    class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                >
                    <vue-feather class="mr-20" type="book-open" size="15"></vue-feather>
                    <span> {{ localizationStore.translate('Knowledge Base') }} </span>
                </router-link>
            </li> -->
            <!-- <li class="nav-item">
                <router-link
                    :to="{ name: 'blogs'}"
                    class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                >
                    <vue-feather class="mr-50" type="circle"></vue-feather>
                    <span>{{ localizationStore.translate('Blog') }}</span>
                </router-link>
            </li> -->
            <li class="dropdown nav-item sidebar-group-active open">
                <a href="#" target="_self"
                    class="nav-link dropdown-toggle d-flex align-items-center px-50 text-primary">
                    <vue-feather class="mr-20" type="briefcase" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('creditfixrr.tools') }}</span></a>
                <ul class="dropdown-menu">
                    <li class="">
                        <router-link
                            :to="{ name: 'disputes-letter-add'}"
                            class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                        >
                            <vue-feather class="mr-50" type="file-text" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('letter.custom.add') }}</span>
                        </router-link>
                    </li>
                    <li class="">
                        <router-link
                            :to="{ name: 'mails-list'}"
                            class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                        >
                            <vue-feather class="mr-50" type="mail" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('lob.letter') }}</span>
                        </router-link>
                    </li>
                    <li class="">
                        <router-link
                            :to="{ name: 'fax-history'}"
                            class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                        >
                            <vue-feather class="mr-50" type="printer" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('fax.history') }}</span>
                        </router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link
                            :to="{ name: 'email-history'}"
                            class="d-flex align-items-center dropdown-item router-link-exact-active router-link-active text-primary"
                        >
                            <vue-feather type="grid" size="15"></vue-feather>
                            <span class="menu-title text-truncate">{{ localizationStore.translate('email.history') }}</span>
                        </router-link>
                    </li> -->
                    <li class="">
                        <router-link
                            :to="{ name: 'invoice-list'}"
                            class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                        >
                            <vue-feather class="mr-50" type="sliders" size="15"></vue-feather>
                            <span class="menu-title">{{localizationStore.translate('Invoice')}}</span>
                        </router-link>
                    </li>
                    <li class="">
                        <router-link
                            :to="{ name: 'credit-contact-index'}"
                            class="nav-link d-flex align-items-center px-2 text-primary" target="_self"
                        >
                            <vue-feather class="mr-50" type="info" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('credit.contact') }}</span>
                        </router-link>
                    </li>
                    <li class="">
                        <router-link
                            :to="{ name: 'order-history'}"
                            aria-current="page" class="align-items-center dropdown-item router-link-exact-active router-link-active text-primary" target="_self"
                        >
                            <vue-feather type="shopping-cart"  class="mr-50" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('order.history') }}</span>
                        </router-link>
                    </li>
                    <!-- <li>
                        <a
                            :href="getRoute('attacks-history', { client: $route.params.client, team: $route.params.team })"
                            class="d-flex align-items-center dropdown-item router-link-exact-active router-link-active text-primary"
                            aria-current="page"
                        >
                            <vue-feather class="mr-50" type="list"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('attack.history') }}</span>
                        </a>
                    </li> -->
                </ul>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'billing-plans'}"
                    aria-current="page" class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                >
                    <vue-feather class="mr-20" type="dollar-sign" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('plans') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'thirty-day-report'}"
                    class="nav-link d-flex align-items-center px-50 text-primary"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="airplay" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('thirty.day.report') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'products'}"
                    class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                >
                    <vue-feather class="mr-20" type="book" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('ebook') }}</span>
                </router-link>
            </li>
            <li class="dropdown nav-item"><a href="#" target="_self" class="nav-link dropdown-toggle d-flex align-items-center px-50 text-primary">
                <vue-feather class="mr-20" type="award" size="15"></vue-feather>
                <span>{{ localizationStore.translate('affiliate.programs') }} </span></a>
                <ul class="dropdown-menu">
                    <li class="">
                        <router-link
                            :to="{ name: 'referrals'}"
                            class="align-items-center dropdown-item router-link-exact-active router-link-active" target="_self"
                        >
                        <vue-feather class="mr-50" type="dollar-sign" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('Affliates') }}</span>
                        </router-link>
                    </li>
                    <li class="">
                        <a href="https://www.smartcredit.com/?PID=54821" aria-current="page" class="align-items-center dropdown-item router-link-exact-active router-link-active">
                            <vue-feather class="mr-50" type="link-2" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('SmartCredit') }}</span>
                        </a>
                    </li>
                    <li class="">
                        <a href="https://self.inc/refer/19760810" aria-current="page" class="align-items-center dropdown-item router-link-exact-active router-link-active">
                            <vue-feather class="mr-50" type="link-2" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('SelfLender') }}</span>
                        </a>
                    </li>
                    <li class="">
                        <a href="https://prf.hn/click/camref:1101ljh9y" aria-current="page" class="align-items-center dropdown-item router-link-exact-active router-link-active">
                            <vue-feather class="mr-50" type="link-2" size="15"></vue-feather>
                            <span class="menu-title">{{ localizationStore.translate('RentReporters') }}</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="nav-item d-md-block d-none my-auto" v-if="user.onTrial">
                <span class="nav-link d-flex align-items-center px-50 text-primary">
                    {{ localizationStore.translate("trail.user.days.left.navbar.message",{days: user.trialEndsDay}) }}
                </span>
            </li>
        </template>
        <!-- right slot - side menu -->
        <template #right_slot>
            <li class="nav-item active">
                <router-link
                    :to="{ name: 'diy-dashboard'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="home" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">Dashboards</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'chat-index'}"
                    class="d-flex align-items-center"
                    target="_self"
                >
                    <vue-feather class="mr-50" type="message-square" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('chat.navbar.title') }}</span>
                </router-link>
            </li>
            <li class="nav-item" v-if="user.hasFamily">
                <router-link
                    :to="{ name: 'family-index'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="users" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('family') }}</span>
                </router-link>
            </li>
            <li class="navigation-header text-truncate">
                <span>{{ localizationStore.translate('Creditfixrr') }}</span>
                <vue-feather type="more-horizontal" size="15"></vue-feather>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'credit-report'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="clipboard" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Credit Report') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    data-toggle="modal"
                    data-target="#credit_analysis_modal_update"
                    class="d-flex align-items-center"
                    target="_self"
                >
                    <vue-feather class="mr-50" type="bar-chart" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('credit.analysis') }}</span>
                </a>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'dispute-report'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather class="mr-50" type="layers" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Dispute Letters') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'authorized-user'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="credit-card" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('user.authorized.user') }}</span>
                </router-link>
            </li>
            <!-- <li class="nav-item knowledge_center">
                <router-link
                    :to="{ name: 'knowledge-base-index'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="book-open" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Knowledge Base') }}</span>
                </router-link>
            </li> -->
            <li class="nav-item">
                <router-link
                    :to="{ name: 'products'}"
                    class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="book" size="15" class="mr-50"></vue-feather>
                    <span>{{ localizationStore.translate('ebook') }}</span>
                </router-link>
            </li>
            <!-- start academy -->
            <li class="nav-item">
                <router-link
                    :to="{ name: 'academy'}"
                    class="d-flex align-items-center" target="_self"
                >
                    <vue-feather class="mr-20" type="monitor" size="15"></vue-feather>
                    <span>Academy Dashboard</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'courses'}"
                    class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="monitor" size="15" class="mr-50"></vue-feather>
                    <span>{{ localizationStore.translate('education.courses') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'user-courses'}"
                    class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="archive" size="15" class="mr-50"></vue-feather>
                    <span>{{ localizationStore.translate('education.user.courses') }}</span>
                </router-link>
            </li>
            <!-- end Academy -->
            <li class="navigation-header text-truncate">
                <span>{{ localizationStore.translate('creditfixrr.tools') }}</span>
                <vue-feather type="more-horizontal" size="15"></vue-feather>
            </li>
            <!-- tools -->
            <li class="nav-item">
                <router-link
                    :to="{ name: 'mails-list'}"
                    class="d-flex align-items-center" target="_self"
                >
                    <vue-feather class="mr-50" type="mail" size="15"></vue-feather>
                    <span class="menu-title">{{ localizationStore.translate('lob.letter') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'fax-history'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="printer" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('fax.history') }}</span>
                </router-link>
            </li>
            <!-- <li class="nav-item">
                <a :href="$router.resolve({ name: 'email-history'}).href" class="d-flex align-items-center">
                    <vue-feather type="grid" size="15"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('email.history') }}</span>
                </a>
            </li> -->
            <li class="nav-item">
                <router-link
                    :to="{ name: 'thirty-day-report'}"
                    class="d-flex align-items-center"
                    target="_self"
                >
                    <vue-feather class="mr-50" type="airplay" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('thirty.day.report') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'invoice-list'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="sliders" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Invoice') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'credit-contact-index'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="info" size="15" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('credit.contact') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'order-history'}"
                    aria-current="page" class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="shopping-cart"  class="mr-50" size="15"></vue-feather>
                    <span class="menu-title">{{ localizationStore.translate('order.history') }}</span>
                </router-link>
            </li>
            <li class="navigation-header text-truncate">
                <span>{{ localizationStore.translate('Creditfixrr Blog') }}</span>
                <vue-feather type="more-horizontal" size="15"></vue-feather>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'blogs'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="book-open" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Blog') }}</span>
                </router-link>
            </li>
            <li class="navigation-header  text-truncate">
                <span>{{ localizationStore.translate('Refer Friends & Family') }}</span>
                <vue-feather type="more-horizontal"></vue-feather>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'referrals'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="dollar-sign" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('Affliates') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <a href="https://www.smartcredit.com/?PID=54821" class="d-flex align-items-center" >
                    <vue-feather type="dollar-sign" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('SmartCredit') }}</span>
                </a>
            </li>
            <li class="nav-item">
                <a href="https://self.inc/refer/19760810" class="d-flex align-items-center" >
                    <vue-feather type="link-2" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('SelfLender') }}</span>
                </a>
            </li>
            <li class="nav-item">
                <a  href="https://prf.hn/click/camref:1101ljh9y" class="d-flex align-items-center" >
                    <vue-feather type="link-2" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('RentReporters') }}</span>
                </a>
            </li>
            <li class="navigation-header  text-truncate">
                <span>{{ localizationStore.translate('User Settings') }}</span>
                <vue-feather type="more-horizontal"></vue-feather>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'user-account'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="user" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('UserProfile') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'billing-subscriptions-plan'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="credit-card" class="mr-50"> </vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('billing') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'billing-plans'}"
                    aria-current="page" class="d-flex align-items-center" target="_self"
                >
                    <vue-feather class="mr-20" type="dollar-sign" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('plans') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'settings'}"
                    aria-current="page"  class="d-flex align-items-center" target="_self"
                >
                    <vue-feather type="settings" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('settings') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <a  href="https://creditfixrr.crunch.help/en" class="d-flex align-items-center" >
                    <vue-feather type="help-circle" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('RentReporters') }}</span>
                </a>
            </li>
            <li class="nav-item" v-if="user.onTrial">
                <a class="nav-link d-flex align-items-center text-primary" href="#">
                    {{ localizationStore.translate("trail.user.days.left.navbar.message",{days: user.trialEndsDay}) }}
                </a>
            </li>
            <li class="nav-item">
                <a @click="logout" href="#" class="d-flex align-items-center">
                    <vue-feather type="log-out" class="mr-50"></vue-feather>
                    <span class="menu-title text-truncate">{{ localizationStore.translate('UserLogout') }}</span>
                </a>
            </li>
        </template>
    </nav-bar-layout>
    <credit-analysis-modal></credit-analysis-modal>
</template>
<script>
import NavBarLayout from './layouts/NavBarLayout'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../stores/UserStore.js'
import { ref } from 'vue'
import { getRoute } from '../../../utilities/_helpers'
export default {
    components: {
        NavBarLayout
    },
    props: {
        user: {
            type:[Array,Object]
        },
    },
    setup(props) {
        return {
            localizationStore: useLocalizationStore(),
            userStore:useUserStore(),
            getRoute: getRoute
        }
    },
    created() {
    },
    methods: {
        logout() {
            const route = this.$router.resolve({ name: 'logout-link'}).href;
            axios.get(route)
            .then(function (response) {
                localStorage.clear();
                location.reload();
            });
        }
    }
}
</script>

